import React from 'react';

import Card from '@material-ui/core/Card';
import { createMuiTheme, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import { Notification, Loading,
    useTranslate, useRedirect } from 'react-admin';

import { API_HOST } from '../env';

    const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flexFlow: 'row wrap',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: '#E6E6E6',
  },
  subbox: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    width: '100%',
  },
  cardnotice: {
    width: '100%',
    minHeight: '100vh',
  },
  notices: {
    padding: '1em 2em 1em 2em',
    fontSize: 'xx-large',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
  },
  notice: {
    marginBottom: '1ex',
  },
  logo: {
    margin: '10vh 0 2em 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ResultMessage = props => {
  const translate = useTranslate();
  const redirectTo = useRedirect();
  if (!props.success) {
    setTimeout(() => redirectTo('/login'), 5000);
    return (<span>{translate('ra.notification.item_doesnt_exist')}</span>);
  }
  return (
    <span>
      {translate('resources.messages.password_reset.success')}<br />
      <br />
      {translate('resources.messages.password_reset.send')}
    </span>
  );
};

const PasswordReset = props => {
  const [state, setState] = React.useState({ loading: true });
  const classes = useStyles();

  const params = props.match.params;
  const token = `${params['h']}.${params['p']}.${params['s']}`;
  console.log(`token: ${token}`);

  React.useEffect(() => {
    const request = new Request(API_HOST + '/api/supervisors/password_reset', {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}` }),
      credentials: 'omit',
    });
    fetch(request)
      .then(response => {
        const upState = { loading: false };
        if (response.status < 200 || response.status >= 300) {
          console.log("login error:" + response.statusText);
          console.log(response);
          upState.success = false;
        } else {
          upState.success = true;
        }
        setState(upState);
      });
    },
    [token]
  );

  return (
    <div className={classes.main}>
      <div className={classes.subbox}>
        <Card className={classes.cardnotice}>
          <div className={classes.logo}>
            <img alt='Life is Tech!' src='/images/header_logo_black.svg' width='25%' />
          </div>
          {state.loading
            ? (<Loading />)
            : (
              <div className={classes.notices}>
                <ResultMessage success={state.success} />
              </div>
            )
          }
        </Card>
      </div>
      <Notification />
    </div>
  );
};

// We need to put the ThemeProvider decoration in another component
// Because otherwise the useStyles() hook used in Login won't get
// the right theme
const PasswordResetWithTheme = (props) => {
  const theme = {
    palette: {
      secondary: {
        main: '#0C487A',
      },
    },
  };
  return (
    <ThemeProvider theme={createMuiTheme(theme)}>
      <PasswordReset {...props} />
    </ThemeProvider>
  );
};

export default PasswordResetWithTheme;
